import styled from 'styled-components';

export const ClickableImage = styled.img`
  cursor: pointer;
  transition: filter 0.1s ease;

  &:active {
    filter: brightness(0.8); /* 어둡게 눌림 효과 */
  }
`;
